import { Injectable } from '@angular/core';
import { UntypedFormControl,AbstractControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class AutotextService {
  public currentFieldID: number;
  currentText: AbstractControl;
  public Display = false;
  Title: string;
  summaryDiagnosisAT =[];
  filter=null;
  options =[];
  filteredOptions: Observable<string[]>[] = [];
  search = new UntypedFormControl();
  loaded$ = new Subject();
  loaded=false;
  public resetInput$ = new Subject();




  constructor(private http: HttpClient) { }

  showAuto(formObj: AbstractControl,title: string,formID: number, display = true){
    this.currentText = formObj;
    this.Title= title;
    this.currentFieldID= formID;
    this.Display = display;
  }

  getTexts(field = this.currentFieldID.toString(), filter = this.filter){
    let res = this.http.get('/api/autotext',{params:{field:field, filter:filter}});
    return res;
  }

  saveText(txt:string,id:number, move = false, priority: number = null, isClinic: boolean = false){
    if(move){
      let res = this.http.post('/api/autotextMove',{Text: txt, DlgID: this.currentFieldID});
      return res;
    }
    // If isClinic is explicitly true, use that; otherwise use this.filter (which might be null or a filter value)
    let filter = isClinic ? true : this.filter;
    let body: any = {Text: txt, DlgID: this.currentFieldID, ID: id, filter: filter};
    // Only include Priority if it's explicitly set
    if(priority !== null && priority !== undefined) {
      body.Priority = priority;
    }
    let res = this.http.post('/api/autotext', body);
    return res;
  }

  delete(id:number){
    let res = this.http.delete('/api/autotext',{params:{ID: id.toString()}});
    return res;
  }

  updatePriority(id:number, priority:number, isClinic:boolean = false){
    let res = this.http.post('/api/autotext/priority',{ID: id, Priority: priority, isClinic: isClinic});
    return res;
  }

  close(){
    this.Display=false;

  }
  private _filter(value: string,field:number): string[] {
    const filterValue = value.toLowerCase();
    return this.options[field].filter(option => option.toLowerCase().includes(filterValue));
  }

  async loadData(form: UntypedFormControl, fieldid: number = 0){
    this.loaded = false;
    await this.http.get('/api/newExams/getAutoInput/'+ fieldid).subscribe((data:any) => {
      this.options[fieldid] = [];
      if(data.length > 0){
        data.forEach((i) => {
          this.options[fieldid].push(i.Text)
        })
      }
      this.filteredOptions[fieldid] = form.valueChanges.pipe(startWith(''),map(value => this._filter('',fieldid)));
      this.loaded$.next(undefined);
      this.loaded = true
    })
    
  }
  deleteAuto(option, field: number=0){
    this.http.delete("/api/newExams/deleteOption/"+option+'/' + field).subscribe((data) =>{
     this.options[field] = this.options[field].filter(e => e !== option);
      this.filteredOptions[field] = this.search.valueChanges.pipe(startWith(''),map(value => this._filter('',field)));
    })
  }
}
